import { useState, useEffect, useContext } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import { FormField } from '../../../../Components/FormField';
import SidebarField from '../../../../Components/SidebarField';
import TextInput from '../../../../Components/TextInput';
import Button from '../../../../Components/Button';
import { RoleApi } from '../../../../App/api/role_and_permissions.api';
import LoaderContext from '../../../../Components/loader';
import ToggleField from '../../../../Components/ToggleField';

function AddRole({ currentItems, getAllData, open, handleClose }) {
  const {handleLoading}=useContext(LoaderContext)
  
  const initialValues = {
    name: currentItems?.name || '',
    role_id: currentItems?.role_id || '',    
    active: currentItems?.active || '',    

  };
  
  const handleSubmit = async (values, { resetForm }) => {
    console.log("Data",values);
    handleLoading(true)
    try {
      console.log('values', values);
      // Logic for creating or updating the role and permissions
      const response = currentItems?._id
        ? await RoleApi.updateRole(values, currentItems._id)
        : await RoleApi.createRole(values);

        getAllData();
      toast.success(currentItems?._id ? 'Role updated' : 'Role created');
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
    handleLoading(false)
  };



  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        //   validationSchema={RolePermissionsSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={currentItems?._id ? 'Update Role' : 'Add New Role'}
                button1={<Button text="Cancel" type="button" onClick={handleClose} />}
                button2={<Button text={currentItems?._id ? 'Update' : 'Submit'} type="submit" />}
              >
                <FormField label="Role" tooltip="Enter role name">                    
                     <TextInput
                      name="name"
                      type="text"
                      value={values.name}
                      placeholder="Role"
                      onChange={handleChange}
                      className="outline-none capitalize"
                      required={true}
                    />
                  <ErrorMessage name="name" component="p" className="error" />
                </FormField>                
                <FormField label="Role Id" tooltip="Enter role Id">                    
                     <TextInput
                      name="role_id"
                      type="number"
                      value={values.role_id}
                      placeholder="Role"
                      onChange={handleChange}
                      className="outline-none capitalize"
                      min={0}   
                      required={true}                   
                    />
                  <ErrorMessage name="role_id" component="p" className="error" />
                </FormField>   
                <div>
                <ToggleField
                  text={values.active?"Enabled":'Disabled'}
                  name="active"
                  value={values.active}
                  toggaleHandleChange={(e)=>{
                    console.log("v",e.target.value);
                    
                    setFieldValue('active',e.target.value)
                  }}
                />   
                <ErrorMessage name="active" component="p" className="error" />
                </div> 
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddRole;
